export default 
{
	"And": "and",
	"Are you sure you want to discard your changes?": "Are you sure you want to discard your changes?",
	"authenticated-save-and-resume-email-dialog": "Email a link and return to your form to complete your submission.",
	"Continue with {provider}": "Continue with {provider}",
	"Continue with email": "Continue with email",
	"ContinueButton": "Continue",
	"Discard Changes": "Discard Changes",
	"Due Date": "Due Date",
	"EditProfile": "Edit Profile",
	"Good Afternoon": "Good Afternoon",
	"Good Evening": "Good Evening",
	"Good Morning": "Good Morning",
	"GroupTasksBy": "Group By",
	"Homepage": "Home",
	"I Agree": "I agree to the   ",
	"Inactive guest error": "You are not an active guest of",
	"Keep Editing": "Keep Editing",
	"Login - Instruction": "Please continue to access",
	"Logout": "Logout",
	"My Tasks": "My Tasks",
	"people-form-email-quantity-exceeded-message": "Email address must be unique.",
	"Please select a registration form.": "Please select a registration form.",
	"Priority": "Priority",
	"Privacy Policy": "Privacy Policy",
	"Provided By": "provided by",
	"Registration List Header": "How would you like to register?",
	"Status": "Status",
	"Submitted": "Submitted",
	"Tasks": "Tasks",
	"Terms of Service": "Terms of Service",
	"this organization": "this organization",
	"Type": "Type",
	"Unsaved Changes": "Unsaved Changes",
	"Verification - Instruction": "Please enter the code sent to your email address to continue.",
	"Verification - Resend": "Didn’t receive the code? Resend now.",
	"Verification - Title": "Verification Code.",
	"you": "you",
	"You are not a member of": "You are not a member of",
	"You do not have access to this form.": "You do not have access to this form.",
	"You must agree.": "You must agree."
};
